import { renderIsomorphicComponent, renderComponent } from "@quintype/framework/client/start";
import { pickComponent } from "../isomorphic/pick-component";
import { Header } from "../isomorphic/components/header";
import { Footer } from "../isomorphic/components/layouts/footer";
import LoadingIndicatorComponent from "../isomorphic/components/atoms/loading-indicator";
import SubscriptionCTACopy from "../isomorphic/components/molecules/subscription-cta-copy";
import { ShowSuccessMsg } from "../isomorphic/components/molecules/show-success-msg";
import { PlayerContextProvider } from "../isomorphic/components/podcast-player/player-context";

export function preRenderApplication(store) {
  const hydrate = { hydrate: !global.qtLoadedFromShell };
  renderComponent(PlayerContextProvider, "audio-player", store, hydrate);
  renderComponent(Header, "header", store, hydrate);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
  renderComponent(Footer, "footer", store, hydrate);
  renderComponent(ShowSuccessMsg, "show-success-msg", store, hydrate);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  renderIsomorphicComponent("container", store, pickComponent, {
    hydrate: !global.qtLoadedFromShell
  });
  renderComponent(SubscriptionCTACopy, "subscription-cta", store, {
    hydrate: true
  });
}
